import React from 'react';
import styled, { css } from 'styled-components';
import isNil from 'lodash/isNil';

import { IPostfixIconWrapper } from './types';

const PostfixIconWrapper: React.FC<IPostfixIconWrapper> = ({
  className,
  onClick,
  children,
}) => (
  <StyledIconWrapper className={className} onClick={onClick}>
    {children}
  </StyledIconWrapper>
);

const StyledIconWrapper = styled.div<IPostfixIconWrapper>`
  padding-right: 7px;
  display: inline-flex;
  ${({ onClick }) =>
    !isNil(onClick) &&
    css`
      cursor: pointer;
    `}
`;

export default PostfixIconWrapper;
